import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors, useWatch } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { powerUnit } from '../../../../util/formatters'
import { ControlledSwitch } from '../../../form/ControlledSwitch'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function CoolingGroundHeatPumpForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const freeCooling = useWatch<boolean>({
    control,
    name: 'parameters.coolingGroundHeatPump.freeCooling',
  })

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.coolingGroundHeatPump.eer"
          rules={{
            ...validators.required,
            ...validators.eer,
          }}
          error={errors.parameters?.coolingGroundHeatPump?.eer}
          label={t('createProvider.forms.coolingGroundHeatPump.eer')}
          defaultValue="4"
        />
      </FormGroup>

      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.coolingGroundHeatPump.maxPower"
          rules={{
            ...validators.required,
            ...validators.maxPower,
          }}
          error={errors.parameters?.coolingGroundHeatPump?.maxPower}
          label={t('createProvider.forms.coolingGroundHeatPump.maxPower')}
          InputProps={{
            endAdornment: <Typography>{powerUnit}</Typography>,
          }}
        />
      </FormGroup>

      <FormGroup>
        <ControlledSwitch
          control={control}
          name="parameters.coolingGroundHeatPump.freeCooling"
          label={t('createProvider.forms.coolingGroundHeatPump.freeCooling')}
        />
      </FormGroup>

      {freeCooling && (
        <>
          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.coolingGroundHeatPump.freeCoolingEer"
              rules={{
                ...validators.required,
                ...validators.eer,
              }}
              error={errors.parameters?.coolingGroundHeatPump?.freeCoolingEer}
              label={t(
                'createProvider.forms.coolingGroundHeatPump.freeCoolingEer',
              )}
              defaultValue="20"
            />
          </FormGroup>

          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.coolingGroundHeatPump.freeCoolingMaxPower"
              rules={{
                ...validators.required,
                ...validators.maxPower,
              }}
              error={
                errors.parameters?.coolingGroundHeatPump?.freeCoolingMaxPower
              }
              label={t(
                'createProvider.forms.coolingGroundHeatPump.freeCoolingMaxPower',
              )}
              InputProps={{
                endAdornment: <Typography>{powerUnit}</Typography>,
              }}
            />
          </FormGroup>
        </>
      )}
    </>
  )
}
